module.exports = __webpack_public_path__ + "static/img/icon-title-agency.0e939f29.svg";